export const createFilm = (titulo, director, ano, duracion, xenero, pais, premios, trailer, sinopse, poster) => ({
  titulo,
  director,
  ano,
  duracion,
  xenero,
  pais,
  premios,
  trailer,
  sinopse,
  poster,
});
